<template>
  <div class="posts">
    <div class="posts-title">{{postsInfo.articleTitle}}</div>
    <div class="posts-info">
      <!-- 作者及相关详细 -->
      <img width="30px" height="30px" :src="postsInfo.userAvatarUrl || BASE_URL + 'img/zwt.png'" class="posts-info-img" :alt="postsInfo.postsName"/>
      <span>{{postsInfo.postsName}} &nbsp;上传&nbsp;|&nbsp;</span>
      <span>{{postsInfo.articleCommentCount||0}} &nbsp;个回复&nbsp;|&nbsp;</span>
      <span>{{postsInfo.articleViewCount||0}} &nbsp;次游览&nbsp;|&nbsp;</span>
      <span>{{postsInfo.createTime}}</span>
    </div>
    <div class="posts-content">
      <p>{{postsInfo.articleContent}}</p>
    </div>
    <div>
      <ul>
        <li v-for="item in postsInfo.fileList" :key="item">
          <img :src="item.fileUrl" alt="" style="width: 300px">
        </li>
      </ul>
      <img :src="postsInfo.fileUrl">
    </div>
    <!-- 专家信息 -->
    <div class="export-info">
      <!-- 专家图片 -->
      <div class="export-info-img">
        <img :src="postsInfo.expertAvatarUrl || BASE_URL + 'img/zwt.png'" width="162px" height="162px" :alt="postsInfo.expertName"/>
      </div>
      <!-- 专家信息 -->
      <div class="export-info-detail">
        <div class="export-info-detail-name">{{postsInfo.expertName}} 专家</div>
        <!-- 专家标签 -->
        <div class="export-info-detail-category overell"
             v-if="postsInfo&&postsInfo.fileVideoTypeAttributeEntityList&&postsInfo.fileVideoTypeAttributeEntityList.length">
          <span v-for="item in postsInfo.fileVideoTypeAttributeEntityList"
                :key="item.id">{{item.typeAttributeValue}}</span>
        </div>
        <div class="export-info-detail-introduction">
          <p>{{postsInfo.expertIntroduction}}</p>
        </div>
        <div class="export-info-opt">
          <div class="export-info-opt-but"
               @click="routerHandleAskExport(postsInfo.expertId)">我要提问</div>
          <div class="export-info-opt-label">
            <div class="export-about-info"
                 @click.stop="routerHandleExportDetail(postsInfo.expertId, postsInfo.expertUserId)">
              <div class="export-about-info-count">{{postsInfo.questionCount}}</div>
              <div>个提问</div>
            </div>
            <div class="export-about-info"
                 @click.stop="routerHandleExportDetail(postsInfo.expertId, postsInfo.expertUserId)">
              <div class="export-about-info-count">{{postsInfo.replyCount}}</div>
              <div>个回复</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 专家回复  -->
    <div v-if="postsInfo.expertAndSelfPostList && postsInfo.expertAndSelfPostList.length">
      <div v-for="item in (showMore?postsInfo.expertAndSelfPostList.slice(0,3):postsInfo.expertAndSelfPostList)"
           :key="item.id">
        <div v-if="item.expertEd&& item.repliyPostUserid !==postsInfo.createUser"
             class="export-reply">
          <div class="export-reply-header">专家回复：</div>
          <div class="export-reply-title">{{item.repliyPostContent}}</div>
        </div>
        <!-- 用户回复内容及相关 -->
        <div class="export-reply-info" v-else>
          <img v-if="item.perfect=== true" class="jpicon" :src="BASE_URL + 'img/perfectIcon.png'" alt="精帖">
          <img :src="item.userAvatarUrl" height="40px" width="40px" :alt="postsInfo.postsName"/>
          <!-- 用户帖子信息 -->
          <div class="export-reply-info-posts">
            <div class="export-reply-info-name">{{item.replyName}}</div>
            <div class="export-reply-info-content">{{item.repliyPostContent}}</div>
            <div class="export-reply-info-time">{{item.createTime}}</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 展开更多 -->
    <div class="comment-more"
         v-if="postsInfo.expertAndSelfPostList&&postsInfo.expertAndSelfPostList.length>3"
         @click="show()">{{showMore? '展开更多':'收起'}}</div>
    <!-- 热门评论 -->
    <div class="hotComment">
      <div class="hotComment-header">热门评论</div>
      <div class="hotComment-content">
        <el-input type="textarea"
                  v-model="replyContent"
                  :autosize="{ minRows: 10}"
                  maxlength="500"
                  placeholder="请输入你的评论(最多500字)..."></el-input>
        <div class="hotComment-content-button"
             v-show="access_token">
          <div :class="'hotComment-content-button-but '+(butLoading?'but-loading':'')"
               @click="submitHandle()">
            <i class="el-icon-loading"
               v-if="butLoading"></i>
            发表
          </div>
        </div>
      </div>
    </div>
    <!-- 普通评论 -->
    <div v-if="ordinaryCommentlist&&ordinaryCommentlist.length">
      <div class="ordinary-comment-info" v-for="item in ordinaryCommentlist" :key="item.id">
        <img v-if="item.perfect=== true" class="jpicon" :src="BASE_URL + 'img/perfectIcon.png'" alt="精贴">
        <img :src="item.userAvatarUrl" height="52px" width="52px" :alt="item.replyName"/>
        <!-- 用户帖子信息 -->
        <div class="export-reply-info-posts">
          <div class="export-reply-info-name">
            {{item.replyName}}
          </div>
          <div class="export-reply-info-content">{{item.repliyPostContent}}</div>
          <div class="export-reply-info-time">{{item.createTime}}</div>
        </div>
      </div>
    </div>
    <!-- 分页 -->
    <!--  v-if="exportList === null || exportList.length !== 0" -->
    <div class="pagination">
      <div class="doclist-pagination">
        <div class="doclist-lastpage"
             @click="jumpLastPage">上一页</div>
        <div class="doclist-omit">{{lastOmit}}</div>
        <ul>
          <li :class="item === currentPage?'pageactive':''"
              v-for="(item, index) in pageList"
              :key="index"
              @click="changePageTo(item)">{{item}}</li>
        </ul>
        <div class="doclist-omit">{{nextOmit}}</div>
        <div class="doclist-nextpage"
             @click="jumpNextPage">下一页</div>
        <div class="doclist-pagejump">共{{totalPage}}页，到第<input type="text"
                 v-model.number="jumpTargetPage">页</div>
        <div class="doclist-jump"
             @click="jumpFarPage">确定</div>
      </div>
    </div>
  </div>
</template>
<script>
import { getAccessToken } from '@/utils/userInfo'
import { expertDetail, expertPutQuestionsTo } from '@/utils/eventTracking'
export default {
  data () {
    return {
      BASE_URL: process.env.BASE_URL,
      butLoading: false,
      postsInfo: {},
      ordinaryCommentlist: [], // 普通用户评论列表
      replyContent: '',
      showMore: true,
      // 分页
      currentPage: 1, // 当前页
      totalPage: 4, // 总页数
      lastOmit: '',
      nextOmit: '...',
      pageList: [],
      jumpTargetPage: 1 // 跳转页
    }
  },
  computed: {
    postsId () {
      return this.$route.query.id
    },
    access_token () {
      return getAccessToken()
    }
  },
  mounted () {
    if (this.postsId) {
      this.getPostsInfo()
      this.getOrdinaryComment(1)
    }

    console.log(this.postsInfo)
  },
  watch: {
    postsId (val) {
      if (val) {
        this.getPostsInfo()
        this.getOrdinaryComment(1)
      }
    }
  },
  methods: {
    // 上一页
    jumpLastPage () {
      if (this.currentPage > 1) {
        var newCurrent = this.currentPage - 1
        this.changePageTo(newCurrent)
      } else {
        this.$message.info('这已经是第一页啦')
      }
    },
    //  下一页
    jumpNextPage () {
      if (this.currentPage < this.totalPage) {
        var newCurrent = this.currentPage + 1
        this.changePageTo(newCurrent)
      } else {
        this.$message.info('这已经是最后一页啦')
      }
    },
    //   第几页
    changePageTo (page) {
      this.getOrdinaryComment(page)
    },
    //   确定跳转到哪页
    jumpFarPage () {
      if (this.jumpTargetPage >= 1 && this.jumpTargetPage <= this.totalPage) {
        this.changePageTo(this.jumpTargetPage)
      } else {
        this.$message.error('请输入正确的页码')
      }
    },
    // 获取帖子信息
    getPostsInfo () {
      this.$http.get(`${window.SITE_CONFIG['apiURL']}/front/kc/expertField/expertuserarticle/articleView/${this.postsId}`)
        .then(({ data }) => {
          if (data && data.code === 0) {
            console.log(data)
            this.postsInfo = data.data
            this.showMore = data.data.expertAndSelfPostList && data.data.expertAndSelfPostList.length > 3
          } else {
            this.postsInfo = {}
            this.showMore = false
          }
        })
    },
    // 获取帖子当前其他用户评论
    getOrdinaryComment (currentPage) {
      this.$http.post(`${window.SITE_CONFIG['apiURL']}/front/kc/expertField/expertuserrepliypost/normalList`, {
        'page': currentPage,
        'limit': 10,
        'articleId': this.postsId
      })
        .then(({ data }) => {
          if (data && data.code === 0) {
            this.ordinaryCommentlist = data.data.data || []
            this.totalPage = Math.ceil(data.data.count / 10)
            this.setPageTo(currentPage)
          } else {
            this.ordinaryCommentlist = []
            this.totalPage = 0
            this.setPageTo(1)
          }
        })
    },
    setPageTo (page) {
      if (this.totalPage > 5) {
        if (page > 2 && page < this.totalPage - 1) {
          var newPageList = []
          for (let index = page - 2; index < page + 3; index++) {
            newPageList.push(index)
          }
          this.pageList = newPageList
          this.currentPage = page
          this.lastOmit = '...'
          this.nextOmit = '...'
        } else if (page <= 2) {
          this.pageList = [1, 2, 3, 4, 5]
          this.currentPage = page
          this.lastOmit = ''
          if (page >= this.totalPage - 2) {
            this.nextOmit = ''
          } else {
            this.nextOmit = '...'
          }
        } else {
          var newPageList2 = [this.totalPage - 4, this.totalPage - 3, this.totalPage - 2, this.totalPage - 1, this.totalPage]
          this.pageList = newPageList2
          this.currentPage = page
          this.lastOmit = '...'
          this.nextOmit = ''
        }
      } else {
        var newPageList5 = []
        for (let index = 1; index <= this.totalPage; index++) {
          newPageList5.push(index)
        }
        this.pageList = newPageList5
        this.lastOmit = ''
        this.nextOmit = ''
        this.currentPage = page
      }
    },
    submitHandle () {
      if (!this.replyContent) {
        this.$message.error('内容不能为空')
        return
      }
      if (!this.butLoading) {
        this.butLoading = true
        this.$http.post(`${window.SITE_CONFIG['apiURL']}/front/kc/expertField/expertuserrepliypost/save`, {
          'userArticleId': this.postsId, // 提问的帖子表id
          'repliyPostContent': this.replyContent // 回帖内容
        })
          .then(({ data }) => {
            if (data && data.code === 0) {
              this.$message.success('评论成功')
              this.replyContent = ''
            } else {
            }
            this.butLoading = false
          })
          .catch(() => {
            this.butLoading = false
          })
      }
    },
    show () {
      this.showMore = !this.showMore
    },
    routerHandleAskExport (id) {
      if (id) {
        expertPutQuestionsTo(this.postsInfo.expertName)
        this.$router.push({
          name: 'askToExpert',
          query: {
            id: id
          }
        })
      }
    },
    // 跳转到专家详细页面
    routerHandleExportDetail (id, userId) {
      expertDetail(this.postsInfo.expertName)
      this.$router.push({
        name: 'exportDetail',
        query: {
          id: id,
          uId: userId
        }
      })
    }
  }
}
</script>
<style scoped>
.posts {
  display: block;
  background-color: #fff;
  padding: 30px 32px;
  word-wrap: break-word;
  word-break: break-all;
}
.posts-title {
  width: 100%;
  /* height: 30px; */
  line-height: 30px;
  text-align: left;
  font-size: 22px;
  color: #333333;
  letter-spacing: 0.66px;
}
.posts-info {
  margin-top: 14px;
  margin-bottom: 20px;
  font-size: 14px;
  width: 100%;
  height: 30px;
  line-height: 30px;
}
.posts-info-img {
  display: inline-block;
  border-radius: 15px;
  margin-right: 10px;
}
.posts-content {
  margin-bottom: 45px;
  text-align: left;
  line-height: 27px;
  font-size: 16px;
  color: #333333;
  letter-spacing: 0.5px;
  word-wrap: break-word;
  width: 100%;
  /* height: 486px; */
}
.export-info {
  /* background-color: #FFFAFA; */
  padding: 10px;
  height: 222px;
  display: flex;
  box-shadow: 1px 2px 9px #888888;
}
.export-info-img {
  /* width: 162px; */
  height: 202px;
  /* display: inline-block; */
}
.export-info-detail {
  /* display: inline-block; */
  margin-left: 20px;
  height: 100%;
  position: relative;
  top: 0;
  width: 100%;
}
.export-info-detail-name {
  text-align: left;
  line-height: 22px;
  font-size: 16px;
  color: #333333;
  height: 22px;
}
.export-info-detail-category {
  margin-top: 12px;
  text-align: left;
  /* height: 20px; */
  line-height: 20px;
  font-size: 14px;
  color: #666666;
  width: 600px;
  overflow: hidden;
  word-wrap: break-word;
}
.export-info-detail-category span {
  margin-right: 10px;
  margin-bottom: 9px;
}
.export-info-detail-introduction {
  width: 95%;
  text-align: left;
  line-height: 24px;
  height: 72px;
  font-size: 14px;
  color: #333333;
  letter-spacing: 0.42px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
  text-overflow: ellipsis;
  /* height: 72px; */
}
.export-info-opt {
  position: absolute;
  bottom: 0;
  left: 0;
  height: 36px;
  width: 100%;
  display: flex;
}
.export-info-opt-but {
  border: 1px solid #1d65a8;
  width: 100px;
  height: 32px;
  line-height: 32px;
  text-align: center;
  color: #1d65a8;
  letter-spacing: 0;
  cursor: pointer;
}
.export-info-opt-but:hover {
  background: #1d65a8;
  color: white;
}
.export-info-opt-label {
  text-align: right;
  margin-right: 19px;
  width: 100%;
}
.export-about-info {
  display: inline-block;
  margin-left: 40px;
  text-align: center;
  line-height: 20px;
  font-size: 14px;
  letter-spacing: 0;
  text-align: center;
  cursor: pointer;
}
.export-about-info:hover {
  color: #1d65a8;
}
.export-about-info-count {
  color: #1d65a8;
}
/* 专家回复 */
.export-reply {
  padding-top: 30px;
}
.export-reply-header {
  text-align: left;
  line-height: 22px;
  font-size: 16px;
  color: #e99436;
  letter-spacing: 0.46px;
  width: 83px;
}
.export-reply-title {
  margin-top: 10px;
  text-align: left;
  line-height: 24px;
  font-size: 16px;
  color: #333333;
  letter-spacing: 0.57px;
  width: 100%;
  padding-bottom: 21px;
  border-bottom: 1px solid #eeeeee;
}
.export-reply-info {
  position: relative;
  margin-top: 10px;
  display: flex;
}
.export-reply-info .jpicon {
  position: absolute;
  width: 40px;
  height: 40px;
  right: 0px;
  transform: rotate(90deg);
  border-radius: 0;
}
.export-reply-info img {
  border-radius: 26px;
  overflow: hidden;
}
.export-reply-info-posts {
  width: 100%;
  word-break: break-all;
  word-wrap: break-word;
  padding-left: 15px;
  text-align: left;
}
.export-reply-info-name {
  width: 100%;
  text-align: left;
  line-height: 22px;
  font-size: 16px;
  color: #333333;
  text-align: left;
  padding-bottom: 4px;
}
.export-reply-info-content {
  text-align: left;
  line-height: 22px;
  font-size: 16px;
  color: #333333;
  letter-spacing: 0.5px;
  width: 100%;
}
.export-reply-info-time {
  padding-top: 4px;
  line-height: 20px;
  font-size: 14px;
  color: #999999;
}
/* 展开更多 */
.comment-more {
  cursor: pointer;
  margin-top: 17.5px;
  width: 100%;
  height: 30px;
  line-height: 27px;
  text-align: center;
  color: #eeeeee;
  font-size: 12px;
  background: url("/static/img/gengduo.png") no-repeat top center;
}
/* 热门评论 */
.hotComment {
  padding-top: 30px;
}
.hotComment-header {
  line-height: 30px;
  font-size: 22px;
  color: #333333;
  height: 30px;
  /* padding-bottom: 20px; */
}
.hotComment-content {
  padding-top: 20px;
}
.hotComment-content-button {
  padding-top: 20px;
  text-align: right;
  align-items: right;
  /* float: right; */
}
.hotComment-content-button-but {
  background: #1d65a8;
  text-align: center;
  width: 150px;
  height: 40px;
  line-height: 40px;
  color: #fff;
  cursor: pointer;
}
.but-loading {
  opacity: 0.5;
  /* background-color: #409eff; */
}
/* 普通评论 */
.ordinary-comment-info {
  display: flex;
  margin-top: 30px;
  padding-bottom: 30px;
  border-bottom: 1px solid #e7e7e7;
  position: relative;
}
.ordinary-comment-info .jpicon {
  position: absolute;
  width: 40px;
  height: 40px;
  right: 0px;
  transform: rotate(90deg);
  border-radius: 0;
}
.ordinary-comment-info img {
  border-radius: 26px;
  overflow: hidden;
}
p {
  margin: 0;
}
</style>
